(ns common.schema.entities.workspace.kyc.questions.substantial-us-owner
  (:require
   [common.country :as country]
   [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]))

(def tax-reference-type-options
  [{:key :tax-reference-type/ssn
    :ord 1.0
    :translations {:en "Social Security Number (SSN)"}}
   {:key :tax-reference-type/itin
    :ord 2.0
    :translations {:en "Individual Taxpayer Identification Number (ITIN)"}}
   {:key :tax-reference-type/ein
    :ord 3.0
    :translations {:en "Employer Identification Number (EIN)"}}
   {:key :tax-reference-type/other
    :ord 4.0
    :translations {:en "Other"}}])

(def all-questions
  {:kyc-substantial-us-owner/full-name
   {:data/type :data.type/text-simple
    :translations {:en "Full name"}}

   :kyc-substantial-us-owner/street-address
   {:data/type :data.type/text-simple
    :translations {:en "Street address"}}

   :kyc-substantial-us-owner/city
   {:data/type :data.type/text-simple
    :translations {:en "City"}}

   :kyc-substantial-us-owner/zip-code
   {:data/type :data.type/text-simple
    :translations {:en "Zip code"}}

   :kyc-substantial-us-owner/country
   {:data/type :data.type/keyword
    :options country/options
    :translations {:en "Country"}}

   :kyc-substantial-us-owner/tax-reference-type
   {:data/type :data.type/keyword
    :options tax-reference-type-options
    :translations {:en "Tax reference type"}}

   :kyc-substantial-us-owner/tax-identification-number
   {:data/type :data.type/text-simple
    :translations {:en "Tax identification number"}}})
